export type ChildSlot = {
    slotId: string
    childBlockConfigIds: string[]
}

export type LayoutBlockHandler = {
    getChildSlots: (props: Record<string, unknown>) => ChildSlot[]
    updateChildIds: (props: Record<string, unknown>, idMapping: Map<string, string>) => void
}

const containerHandler: LayoutBlockHandler = {
    getChildSlots: props => {
        const ids = (props.childBlockConfigIds as string[]) || []
        return [{ slotId: 'default', childBlockConfigIds: ids }]
    },
    updateChildIds: (props, idMapping) => {
        if (props.childBlockConfigIds) {
            props.childBlockConfigIds = (props.childBlockConfigIds as string[]).map(
                id => idMapping.get(id) || id
            )
        }
    },
}

const gridHandler: LayoutBlockHandler = {
    getChildSlots: props => {
        const items = (props.items as Array<{ id: string; childBlockConfigIds?: string[] }>) || []
        return items.map(item => ({
            slotId: item.id,
            childBlockConfigIds: item.childBlockConfigIds || [],
        }))
    },
    updateChildIds: (props, idMapping) => {
        if (props.items) {
            props.items = (
                props.items as Array<{ id: string; childBlockConfigIds?: string[] }>
            ).map(item => ({
                ...item,
                childBlockConfigIds: item.childBlockConfigIds?.map(id => idMapping.get(id) || id),
            }))
        }
    },
}

const tabsHandler: LayoutBlockHandler = {
    getChildSlots: props => {
        const items = (props.items as Array<{ id: string; childBlockConfigIds?: string[] }>) || []
        return items.map(item => ({
            slotId: item.id,
            childBlockConfigIds: item.childBlockConfigIds || [],
        }))
    },
    updateChildIds: (props, idMapping) => {
        if (props.items) {
            props.items = (
                props.items as Array<{ id: string; childBlockConfigIds?: string[] }>
            ).map(item => ({
                ...item,
                childBlockConfigIds: item.childBlockConfigIds?.map(id => idMapping.get(id) || id),
            }))
        }
    },
}

export const layoutBlockHandlers: Record<string, LayoutBlockHandler> = {
    container: containerHandler,
    grid: gridHandler,
    tabs: tabsHandler,
}

export function getLayoutBlockHandler(blockType: string): LayoutBlockHandler | undefined {
    return layoutBlockHandlers[blockType]
}

export function updateLayoutBlockChildIds(
    blockType: string,
    props: Record<string, unknown>,
    idMapping: Map<string, string>
): boolean {
    const handler = getLayoutBlockHandler(blockType)
    if (handler) {
        handler.updateChildIds(props, idMapping)
        return true
    }
    return false
}
